<template>
    <div class="gh-form" v-loading.fullscreen.lock="isProcessing" :element-loading-text="loadingText">
        <div class="gh-form__wrapper">
            <a ref="download"></a>
            <transition name="el-fade-in">
                <div v-show="hasError"
                     v-html="errorMessage"
                     class="gh-form__response is-error">
                </div>
            </transition>

            <el-form
                    :model="form"
                    :rules="form.validationRules"
                    @keyup.enter.native="attemptSubmit('elForm')"
                    ref="elForm"
                    class="gh-form__content">
                <!-- Profile -->
                <div class="gh-form__group">
                    <el-form-item prop="event">
                        <label class="gh-form__label">Select Event*</label>
                        <el-select v-model="form.event" placeholder="Select ">
                            <el-option
                                    v-for="event in availableEvents"
                                    :key="event.id"
                                    :label="event.label"
                                    :value="event.slug">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <div class="gh-form__group">
                    <el-form-item prop="email">
                        <label class="gh-form__label">Email Address*</label>
                        <el-input v-model="form.email" type="email" name="email"></el-input>
                    </el-form-item>
                </div>

                <div class="gh-form__group">
                    <el-form-item prop="checkedDeclare" class="c-form__item c-form__tnc">
                        <el-checkbox v-model="form.checkedDeclare">
                            I hereby declare that I have attended/watched this event.
                        </el-checkbox>
                    </el-form-item>
                </div>
                <!-- Actions -->
                <div class="gh-form__actions">
                    <el-button class="gh-button gh-button--cta" @click="attemptSubmit('elForm')"
                               :disabled="form.processing">
                        {{ computedSubmitButtonLabel }}
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import formMixin from '../mixins/form';
    import { isPast } from 'date-fns'

    export default {
        mixins: [formMixin],

        data() {
            return {
                submitButtonLabel: 'GET CERTIFICATE'
            }
        },

        computed: {
            loadingText() {
                return `Generating your Certificate of Attendence...`;
            },

            errorMessage() {
                const message = {
                    not_found_attendee: `We couldn't find that email address! Please check your spelling or try an alternative email.`,
                }[this.error.message];

                return message || 'Unable to generate your certificate';
            },

            availableEvents() {
                return this.events.filter(event => event.certificateDownloadable)
            }
        },

        methods: {
            handleSubmit() {
                this.$store.dispatch('eventDocument/generateCertificate', this.formPayload)
                    .then(url => {
                        this.form.processing = false;
                        this.reset();

                        window.location.href = url;
                    })
                    .catch(_ => this.form.processing = false);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .gh-form {
        max-width: 480px;
    }

    .gh-form__response {
        margin-bottom: 2rem;
    }
</style>